import DetalleEditorial from "components/Interfester/DetalleEditorial"
import VideoTop from "components/Interfester/VideoTop"
import user1 from "../../assets/images/user_without_pic.png"
import { Fragment, useEffect, useState } from "react"
import { MetaTags } from "react-meta-tags"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import proxInterfester from "../../assets/images/prox_interfester.svg"
import proxCursos from "../../assets/images/prox_cursos_presenciales.jpg"
import proxWebinar from "../../assets/images/prox_webinar.svg"
import { useDispatch, useSelector } from "react-redux"
import {
  getUsersByRole,
  meNew,
} from "store/actions"
import { useGetLocationsQuery } from "store/api/locationsApi"
import { useGetEventsQuery } from "store/api/eventsApi"
import moment from "moment"
import EventsTree from "components/Interfester/EventsTree"

const Eventos = () => {
  const dispatch = useDispatch()
  const [availableEvents, setAvailableEvents] = useState([])

  const { data: locations = [] } = useGetLocationsQuery()

  const {
    whoIAm,
    whoIAmNew,
    usersByRole,
  } = useSelector(state => ({
    whoIAm: state.Profile.user,
    usersByRole: state.UsersList.usersByRole,
    whoIAmNew: state.ProfileNew.user,
  }))

  const { data: events = [], isSuccess: done } = useGetEventsQuery(undefined, {
    skip: usersByRole.length === 0 || locations.length === 0,
  })

  const userId = whoIAm?.idUsuario ?? 0
  const profileId = whoIAm?.idRol ?? 0
  const softskillsProfileId = whoIAmNew?.softskillsProfileId ?? 0

  useEffect(() => {
    dispatch(getUsersByRole(2))
    dispatch(meNew())
  }, [])

  useEffect(() => {
    if (done) {
      const enriched = [...events]
        .sort((a, b) => new Date(a.fechaInicio) - new Date(b.fechaInicio))
        .map(event => {
          const location = locations.find(
            loc => loc.locationId === event.locationId
          )
          const user = usersByRole.find(
            u => u.userId === event.responsibleUserId
          )
          return {
            ...event,
            locationName: location?.name ?? event.locationName,
            responsibleUserName: user
              ? `${user.firstName} ${user.lastName}`
              : "",
          }
        })

      setAvailableEvents(
        enriched.filter(event => {
          const now = moment(new Date())
          const endDate = moment(new Date(event.endDate))
          const diff = endDate.diff(now, "days")
          const blockView = softskillsProfileId === 0 && event.eventId === 26
          return event.status === 1 && diff >= -1 && !blockView
        })
      )
    }
  }, [events, done])

  return (
    <Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Eventos | La Academia Fester</title>
        </MetaTags>
        <Container fluid>
          <Card>
            <CardBody>
              <Row>
                <Col sm={4}>
                  <h3>Próximos eventos</h3>
                </Col>
                <Col sm={8}>
                  <Breadcrumbs
                    breadcrumbItems={[
                      {
                        key: "start",
                        title: "La Academia Fester",
                        link: "/Start",
                      },
                      { key: "eventos", title: "Eventos" },
                    ]}
                  />
                </Col>
                <Col sm={12}>
                  <p>
                    Cada mes, se celebran grandes eventos de Fester y sus
                    productos en las diferentes regiones del pais. Plantéese
                    asistir a alguno cerca suyo para conocer a más gente en la
                    comunidad, aprender sobre especificaciones y desarrollar
                    nuevas habilidades. También puede tomarlos en línea.
                  </p>
                </Col>
              </Row>
              <EventsTree events={availableEvents} />
            </CardBody>
          </Card>
        </Container>
      </div>
    </Fragment>
  )
}

export default Eventos
